// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"9aad92cc","565":"37c491e4","828":"89c19892","987":"0ce8b0ff"}[chunkId] + ".chunk.js";
};